// export default () => ({
// })

export default () => ({
    countries: [],
    countriesSelectable: [],
    countriesPaginatedData: null,
    country: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})